import { CardOrderBase } from "./CardOrderBase";

export class CardOrderControlCard extends CardOrderBase{
   
    GyldighedStartDato:Date | null = null;
    KortNrTidligereKort:string = "";
    UdloebsDato:Date | null = null;
    UdstedendeMyndighed:string = "";
    PolitiMyndighed: string = "";
    WrxNummer: string = "";
    Antal:string = "";
    Malfunctioning:boolean = false;
    IsAndenGeneration:string = "";
    FotoData:string = "";

    StamkortReferenceNr:string|null = null;
}